import React from 'react';
import '../../styles/layout/Footer.css';

function Footer() {
  return (
    <footer className="page-footer">
      <div className="footer-powered">Powered by Links AI Group</div>
      <div className="footer-info">
        <span>גרסה 2.1.0</span>
        <span className="footer-separator">|</span>
        <span className="footer-status">מערכת פעילה</span>
      </div>
    </footer>
  );
}

export default Footer;